import Cookies from 'js-cookie';

/**
 * Ambient auth token for non-React call sites (the axios middleware in particular).
 *
 * Inside a third-party iframe the `token` cookie on `.sportision.de` is blocked or
 * partitioned by Safari ITP and Chrome's third-party cookie phase-out, so the
 * cookie-based auth path silently degrades to "guest". The embed therefore keeps its
 * token in memory and mirrors it here so writes can send an explicit bearer header.
 *
 * Outside the embed `activeToken` stays null and every read falls back to the cookie,
 * which keeps the behaviour bit-identical to before.
 */
let activeToken: string | null = null;

/** Store the in-memory token used for API writes; pass null to fall back to the cookie. */
export const setActiveToken = (token: string | null) => {
    activeToken = token || null;
};

/** Resolve the token for an API request: in-memory first, cookie as fallback. */
export const getActiveToken = (): string | null => activeToken || Cookies.get('token') || null;
